import React from 'react';
import { Modal, Typography } from '../';

import '../../styles/modal.scss';

export const AppModal = ({
    open,
    title,
    onSubmit = () => {},
    onCancel,
    header = true,
    children,
    footer = null,
    closable = true,
    maskClosable = false,
    ...props
}) => {
    return (
        <Modal
            className="rm-modal"
            title={!header ? title : null}
            open={open}
            width={500}
            centered
            onOk={onSubmit}
            onCancel={onCancel}
            closable={closable}
            maskClosable={maskClosable}
            footer={footer}
            {...props}
        >
            {header && (
                <header className="header">
                    <div className="logo" />
                    <Typography.Title level={3} className="modal-title">
                        {title}
                    </Typography.Title>
                </header>
            )}
            {children}
        </Modal>
    );
};
